import * as React from 'react';

// tslint:disable:max-line-length
export const OfficeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M15 13h-5c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1H1v2c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-2zM15 4h-3V1c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v3H1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h5v-1c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v1h5c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm-5 0H6V2h4v2z" />
    </g>
  </svg>
);
